import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import live from './modules/live'
import config from './modules/config'
import login from './modules/login'
import tim from './modules/tim'
import state from './state.js'
import mutations from './mutations.js'
// import actions from './actions.js'
import getters from './getters.js'
import timStore from './modules/timStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    live,
    config,
    login,
    timStore,
    tim
  },
  state,
  mutations,
  // actions,
  getters
})
